import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { getStyle } from '../../components';
import './enterList.less';
import InputItem from 'antd-mobile/lib/input-item';
import { getUrlParam } from '../../utils';

interface NavPropType {
    prefixCls?: string;
    list: any; // 数据
    len?: any; // 商品为0
    isshop?: any; // 0购物车 1详情来 2购物车来 3待支付来
    pic?: any; // 总价
    index?: any;
    source?: any; // 来源
    onJian?: any; // 商品数量减
    onJia?: any; // 商品数量加
    onNumChange?: any; // 输入数量
    onNumBlur?: any; // 失去焦点事件
    onNumFocus?: any; // 获取焦点事件
    num?: any;
}

/**
 * 确认订单列表条目组件
 * @class EnterList
 * @extends {React.Component<NavPropType, any>}
 */
class EnterList extends React.Component<NavPropType, any> {
    static defaultProps = {
        prefixCls: 'enter-list'
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            list: this.props.list,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({list: nextProps.list});
    }

    render() {
        const {prefixCls, list, source, onJian, onJia, onNumChange, onNumFocus, onNumBlur} = this.props;
        let data = list;
        if (list.skuItems) {
            Object.assign(data, list.skuItems[0]);
        } else {
            Object.assign(data, list.skuItem);
        }
        if (list.orderItems) {
            Object.assign(data, list.orderItems[0]);
        }
        let style = getStyle(this.props);
        return <div style={style} className={`${prefixCls}`}>
            <div className={`${prefixCls}item_box ` + (data.isAddress ? `${prefixCls}item_box_no` : ``)}>
                <div className={prefixCls + 'top_img'}>
                    <img src={data.images} alt=""/>
                    {
                        data.isAddress && (
                            <div>暂不配送</div>
                        )
                    }
                </div>
                <div className={`${prefixCls}main_box`}>
                    <div className={`${prefixCls}name`}>{data.name}</div>
                    <div className={`${prefixCls}prop`} style={{WebkitBoxOrient: 'vertical'}}>
                        {data.skuJson && data.skuJson.replace(/\s+/g, '，')}
                    </div>
                    <div className={`${prefixCls}main_tool clearfix`}>
                        <div className={`${prefixCls}main_pic`}>
                            ￥{data.price && data.price.toFixed(2)}
                        </div>
                        {
                            source == 1 && data.skuJson.length === 0 && data.orderStyles !== 4 && getUrlParam('isNew') !== 'true' ?
                                <div className={`${prefixCls}jianjian_box`}>
                                    <span className={`${prefixCls}jian `} onClick={() => {
                                        onJian(data, data);
                                    }}>
                                        <img
                                            src={data.inventory === 0 || data.num <= 1 ? require('../../images/shop_reduce_gray.png') : require('../../images/shop_reduce.png')}
                                            alt=""
                                        />
                                    </span>
                                    <InputItem
                                        type="number"
                                        className={`${prefixCls}zhi`}
                                        value={data.num}
                                        onChange={(val) => onNumChange(data, val)}
                                        onBlur={() => onNumBlur(data, data)}
                                        onFocus={() => onNumFocus(data)}
                                    />
                                    <span className={`${prefixCls}jia`} onClick={() => {
                                        onJia(data, data);
                                    }}>
                                        <img
                                            src={data.inventory === 0 || data.num === data.inventory ? require('../../images/shop_add_gray.png') : require('../../images/shop_add.png')}
                                            alt=""/>
                                    </span>
                                </div>
                                :
                                <div className={`${prefixCls}num`}><i>X</i>{data.num}</div>
                        }
                    </div>
                </div>
            </div>
        </div>;
    }

    static contextTypes = {
        router: PropTypes.object
    };
}

export default observer(EnterList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/common/enterList.tsx